module.exports = __webpack_public_path__ + "05_glasses_red.7052b2c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/05_glasses_red.png
// module id = i8be
// module chunks = 0